import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getConfiguredCauses, getRootCauseData } from './RootCauseData';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { ReportActions } from '../../../actions/report';
import { taskTypeIdSelector } from '../../../reducers/elementTypes';
import { currentProjectIdSelector } from '../../../reducers/projects';
import { elementTypesSelector } from '../../../reducers/elementTypes';
import {
  shouldLoadReportSelector,
  dailyTaskCompleteReportsSelector,
} from '../../../reducers/reports';
import RootCauseGraph from './RootCauseGraph';
import NoElements from '../../../components/states/NoElements';
import RootCausePie from '../RootCausePie/';
import '../../../styles/RootCauseGraph.css';

const RootCauseGraphSelector = immutableCreatorSelector(
  [
    currentProjectIdSelector,
    elementTypesSelector,
    taskTypeIdSelector,
    shouldLoadReportSelector,
    dailyTaskCompleteReportsSelector,
  ],
  (
    currentProjectId,
    elementTypes,
    taskTypeId,
    shouldLoadReport,
    dailyTaskCompleteReports,
  ) => ({
    currentProjectId,
    elementTypes,
    taskTypeId,
    shouldLoadReport,
    dailyTaskCompleteReports,
  }),
);

@connect(RootCauseGraphSelector) // eslint-disable-next-line react/prefer-stateless-function
export default class RootCauseGraphContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    currentProjectId: PropTypes.string,
    taskTypeId: PropTypes.string,
    dailyTaskCompleteReports: PropTypes.object,
    shouldLoadReport: PropTypes.bool,
    elementTypes: PropTypes.object,
  };

  componentDidMount = () => {
    const { dispatch, currentProjectId, shouldLoadReport } = this.props;

    if (shouldLoadReport) {
      dispatch(ReportActions.getReports(currentProjectId));
    }
  };

  componentWillUpdate = () => {
    const { dispatch, currentProjectId, shouldLoadReport } = this.props;

    if (shouldLoadReport) {
      dispatch(ReportActions.getReports(currentProjectId));
    }
  };

  render() {
    const {
      dispatch,
      currentProjectId,
      dailyTaskCompleteReports,
      taskTypeId,
      elementTypes,
      pie,
    } = this.props;

    if (!dailyTaskCompleteReports || !dailyTaskCompleteReports.size) {
      if (pie) {
        return (
          <div
            style={{
              border: '1px solid rgba(0,0,0,0.125)',
            }}
          >
            <NoElements
              missingType="dashboardReport"
              missingEntity="Daily Report"
              dashboard
            />
          </div>
        );
      } else {
        return (
          <NoElements
            missingType="dashboardReport"
            missingEntity="Daily Report"
          />
        );
      }
    }

    // Setup data object
    const data = {};
    const cc =
      elementTypes && elementTypes.size > 0
        ? getConfiguredCauses(elementTypes, taskTypeId)
        : [];
    const { categories, maxTasks, tickValues, values } = getRootCauseData(
      dailyTaskCompleteReports,
      cc,
    );
    data.categories = categories;
    data.values = values;
    data.tickValues = tickValues;
    data.minTick = tickValues[0];
    data.maxTick = tickValues[tickValues.length - 1];
    data.maxTasks = maxTasks;
    // console.log('data: ', data);

    if (pie) {
      return <RootCausePie {...this.props} data={data} />;
    } else {
      return (
        <div style={{ width: '100%', border: '10px solid rgb(241, 241, 241)' }}>
          <RootCauseGraph
            currentProjectId={currentProjectId}
            dispatch={dispatch}
            data={data}
          />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/RootCauseGraph/RootCauseGraphContainer.js